<template>
  <div class="risk-level-container">
    <bCardHeader :param="param"></bCardHeader>
    <div class="risk-level-content">
      <div class="top-title">{{$t('fund.riskTitle')}}</div>
      <div class="level-content" v-if="result">
        <div  :class="[`bg-type${result || 'R1'}`, 'top-info']" >
          <div class="left-content">
            <div class="top-text">{{$t('fund.resultText')}}</div>
            <div class="level-text">{{levelMap[result] && levelMap[result].target}} <img
                  class="marks-img"
                  src="@/assets/images/account/quotation.png"
                  alt=""></div>
            <div class="level-des">{{levelMap[result] && levelMap[result].desc}}</div>
          </div>
          <div class="right-content">
            <img :src="levelMap[result].background" alt="">
          </div>
        </div>
        <div class="description-box">
          <div class="top">
            <span>{{$t('fund.category')}}</span>
            <span>{{$t('fund.desc')}}</span>
          </div>
          <div class="main">
            <div class="item">
              <span>{{$t('fund.investorType')}}</span>
              <span>{{resultDes.isProfessionalInvestor}}</span>
            </div>
            <div class="item">
              <span>{{$t('fund.riskTitle')}}</span>
              <span>{{levelMap[result] && levelMap[result].level}}</span>
            </div>
            <!-- <div class="item">
              <span>{{$t('fund.target')}}</span>
              <span>{{levelMap[result] && levelMap[result].target}}</span>
            </div> -->
            <div class="item">
              <span>{{$t('fund.investmentPeriod')}}</span>
              <span>{{resultDes.timeHorizon}}</span>
            </div>
            <!-- <div class="item">
              <span>{{$t('fund.declareAssets')}}</span>
              <span>{{resultDes.declaredNetAssets}}</span>
            </div> -->
            <!-- <div class="item">
              <span>{{$t('fund.derivativesKnowledge')}}</span>
              <span>{{resultDes.derivativesKnowledge}}</span>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="agree-text">{{$t('fund.agreeRiskText')}}</div> -->
      <div class="agree-text" v-if="!isConfirm">
        <el-checkbox  v-model="isHadAgree">{{$t('fund.readDeclaration')}}</el-checkbox>
      </div>
      <div class="agree-text" v-if="!isConfirm && showCheckSelect">
        <div class="agree-mask" v-if="!ishadRead" @click="showStatement"></div>
        <el-checkbox v-model="ishadRead"  @change="readchange">
          <span>{{ $t('fund.hadAgreeCustomerDeclaration') }}</span>
          <span class="link-text" @click="showStatement">{{ $t('fund.customerDeclaration') }}</span>
        </el-checkbox>
      </div>
      <div class="btn-box">
        <!-- 2个 按钮 -->
        <el-button v-if="!isConfirm" @click="toOpenHandle" :type="isDisabled ? 'disabled' : 'primary'" :disabled="isDisabled">{{ $t('fund.openFund') }}</el-button>
        <div v-if="!isConfirm" @click="toRiskHandle" class="text-btn">{{ $t('fund.btnReEvaluate') }}</div>
        <!-- 只有 1 个按钮 -->
        <el-button v-else @click="toRiskHandle" type="primary" >{{ $t('fund.btnReEvaluate') }}</el-button>
      </div>
      <el-dialog :visible.sync="dialogVisible"
                 width="34%"
                 :title="$t('fund.dialogTitle')"
                 class="cancel-box"
                 :close-on-click-modal="false"
                 :show-close="false">
        <div class="text">{{$t('fund.notBackInfo')}}</div>
        <div class="btns">
          <div class="top"
               @click="dialogVisible=false">{{$t('common.cancel')}}</div>
          <div class="bottom"
               @click="handleBack">{{$t('common.ok')}}</div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogSecondVisible"
                 width="34%"
                 :title="$t('fund.retestTitle')"
                 class="cancel-box"
                 :close-on-click-modal="false"
                 :show-close="false">
        <div class="text">{{$t('fund.secondInfo')}}</div>
        <div class="btns">
          <div class="top"
               @click="suretoRiskHandle">{{$t('fund.totest')}}</div>
          <div class="bottom"
               @click="dialogSecondVisible=false">{{$t('common.cancel')}}</div>
        </div>
      </el-dialog>
    </div>
    <sign :visible.sync="signVisible" @confirm="getSignBase64"></sign>
  </div>
</template>

<script>
import { getRiskLevel, fundCashRiskAgreement, riskQuestions, getOpenAccountStatus } from '@/api/v2/fund'
import eventBus from '@/util/eventBus'
import sign from './components/sign.vue'
export default {
  data() {
    return {
      param: {
        title: 'other_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'other_account'
          }
        ]
      },
      result: '',
      levelMap: {
        R1: {
          enName: 'conservative',
          target: this.$t('fund.level1Text'),
          level: this.$t('fund.level1'),
          desc: this.$t('fund.desText1'),
          background: require('@/assets/images/account/risklevelR1.png'),
          investmentPeriod: this.$t('fund.investmentPeriod1'),
          declareAssets: this.$t('fund.declaredNetAssets1')
        },
        R2: {
          enName: 'robust',
          target: this.$t('fund.level2Text'),
          level: this.$t('fund.level2'),
          desc: this.$t('fund.desText2'),
          background: require('@/assets/images/account/risklevelR2.png'),
          investmentPeriod: this.$t('fund.investmentPeriod2'),
          declareAssets: this.$t('fund.declaredNetAssets2')
        },
        R3: {
          enName: 'balanced',
          target: this.$t('fund.level3Text'),
          level: this.$t('fund.level3'),
          desc: this.$t('fund.desText3'),
          background: require('@/assets/images/account/risklevelR3.png'),
          investmentPeriod: this.$t('fund.investmentPeriod3'),
          declareAssets: this.$t('fund.declaredNetAssets3')
        },
        R4: {
          enName: 'growth',
          target: this.$t('fund.level4Text'),
          level: this.$t('fund.level4'),
          desc: this.$t('fund.desText4'),
          background: require('@/assets/images/account/risklevelR4.png'),
          investmentPeriod: this.$t('fund.investmentPeriod4'),
          declareAssets: this.$t('fund.declaredNetAssets4')
        },
        R5: {
          enName: 'aggressive',
          target: this.$t('fund.level5Text'),
          level: this.$t('fund.level5'),
          desc: this.$t('fund.desText5'),
          background: require('@/assets/images/account/risklevelR5.png'),
          investmentPeriod: this.$t('fund.investmentPeriod5'),
          declareAssets: this.$t('fund.declaredNetAssets5')
        }
      },
      resultDes: {},
      dialogVisible: false,
      toLink: '',
      dialogSecondVisible: false,
      signVisible: false,
      base64: '',
      isHadAgree: false,
      ishadRead: false,
      isConfirm: false,
      questionList: [],
      showCheckSelect: false,
      accountStatus: ''
    }
  },
  components: {
    sign
  },
  created() {
    this.getRiskLevel()
  },
  computed: {
    isDisabled() {
      return !this.isHadAgree || (this.showCheckSelect && !this.ishadRead)
    }
  },
  mounted() {
    this.getQuestionList()
    this.getOpenAccountStatus()
    localStorage.setItem('notNeedPush', 'yes')
    eventBus.$on('openDialog', index => {
      this.toLink = index
      this.dialogVisible = true
    })
  },
  beforeDestroy() {
    localStorage.removeItem('notNeedPush')
    this.dialogVisible = false
    this.toLink = ''
  },
  methods: {
    getQuestionList() {
      riskQuestions().then(res => {
        if (res.code === 200) {
          this.questionList = (res.data && res.data.jsonText) || []
          this.showCheck()
        }
      })
    },
    getOpenAccountStatus() {
      getOpenAccountStatus().then(res => {
        if (res.code === 200) {
          this.accountStatus = res.data ? res.data.status : ''
        }
      })
    },
    showCheck() {
      this.questionList.forEach(item => {
        if ((item.questionNumber === 1 && item.answer === 'E') || (item.questionNumber === 2 && item.answer === 'A')) {
          this.showCheckSelect = true
        }
      })
    },
    readchange() {
      if (!this.ishadRead) {
        this.base64 = ''
      }
    },
    showStatement() {
      this.base64 = ''
      this.signVisible = true
    },
    getSignBase64(val) {
      this.base64 = val
      this.signVisible = false
      this.ishadRead = true
    },
    async getRiskLevel() {
      let params = {
        queryLatestSubmitResult: !!this.$route.query.isLatest
      }
      let res = await getRiskLevel(params)
      if (res && res.code === 200) {
        this.resultDes = res.data
        this.result = res.data.result
        this.isConfirm = res.data.agreement
      }
    },
    // 重新测评
    toRiskHandle() {
      this.dialogSecondVisible = true
    },
    suretoRiskHandle() {
      localStorage.removeItem('notNeedPush')
      this.$router.replace({
        path: '/risk-tip'
      })
    },
    async toOpenHandle() {
      let params = {
        agreement: true
      }
      if (this.showCheckSelect) {
        params.signBase64 = this.base64
      }
      let res = await fundCashRiskAgreement(params)
      if (res && res.code === 200) {
        localStorage.removeItem('notNeedPush')
        if (this.accountStatus && this.accountStatus !== 'REJECT') {
          this.$router.push('/home')
        } else {
          this.$router.replace({
            path: '/risk-disclosure'
          })
        }
      }
    },
    // 确认不保存
    handleBack() {
      this.$router.replace(this.toLink)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-level-container {
  .bg-typeR1 {
      background: linear-gradient( 135deg, #08A7E3 100%, #0076C1 0%);
    }
    .bg-typeR2 {
      background: linear-gradient( 135deg, #07C9D0 100%, #00AAB1 0%);
    }
    .bg-typeR3 {
      background: linear-gradient( 315deg, #1A51CE 100%, #3679FA 0%);
    }
    .bg-typeR4 {
      background: linear-gradient( 135deg, #FFA62B 100%, #F47305 0%);
    }
    .bg-typeR5 {
      background: linear-gradient( 315deg, #F64B41 100%, #FE9366 0%);
    }
  .risk-level-content {
    background: #ffffff;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
    border-radius: 5px;
    min-height: 600px;
    padding: 14px 30px 30px;
  }
  .level-content {
    margin-bottom: 20px;
  }
  .top-title {
    font-size: 18px;
    font-weight: 600;
    color: #182a54;
    line-height: 30px;
    padding-bottom: 16px;
    border-bottom: 3px solid #ebebeb;
    margin-bottom: 19px;
  }
  .top-info {
    max-width: 580px;
    height: auto;
    padding: 10px;
    min-height: 151px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: url('../../../assets/images/account/balance.png') no-repeat;
    background-size: 400px 171px;
    background-origin: content-box;
    color: #ffffff;
    .top-text {
      font-size: 13px;
      font-weight: 400;
      line-height: 13px;
      padding: 16px 0 11px 16px;
    }
    .level-text {
      font-size: 30px;
      font-weight: 500;
      line-height: 30px;
      margin-bottom: 21px;
      padding-left: 16px;
      .marks-img {
        vertical-align: text-top;
      }
    }
    .level-des {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      padding-left: 16px;
    }
  }
  .description-box {
    max-width: 600px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
    border-radius: 0px 0px 4px 4px;
    font-size: 14px;
    font-weight: 400;
    color: #6d748f;
    line-height: 20px;
    box-sizing: border-box;
    padding-bottom: 20px;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 44px;
      background: #f5f6f7;
      padding: 0 30px;
    }
    .item {
      @extend .top;
      background: #fff;
      span {
        &:first-of-type {
          color: #868e9e;
        }
        &:last-of-type {
          color: #24282d;
        }
      }
    }
  }

  .btn-box {
    max-width: 600px;
    .text-btn {
      height: 50px;
      color: #192b57;
      border-radius: 5px;
      border: 1px solid #20315c;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
      box-sizing: border-box;
      cursor: pointer;
      font-weight: 600;
    }
    .el-button {
      width: 100%;
      margin-bottom: 24px;
      height: 50px;
    }
    .right {
      width: 100%;
      border: none;
      background: #fec000;
    }
  }
  .cancel-box {
    // width: 500px;
    margin: 0 auto;
    /deep/ .el-dialog__header {
      margin: 44px 49px 12px;
      padding: 0;
      padding-top: 44px;
      border-bottom: 3px solid #e2e2e2;
    }
    /deep/ .el-dialog__headerbtn {
      right: 30px;
      font-size: 18px;
    }
    /deep/ .el-dialog__title {
      font-size: 22px;
      font-weight: 600;
      color: #24282d;
      line-height: 41px;
    }
    /deep/ .el-dialog__body {
      padding: 0 49px 30px;
    }
    .text {
      font-size: 14px;
      font-weight: 600;
      color: #24282d;
      line-height: 20px;
    }
    .btns {
      font-size: 14px;
      font-weight: 600;
      color: #193060;
      line-height: 20px;
      width: 50%;
      margin: auto;
      text-align: center;
      padding-top: 30px;
      .top {
        background: #fec000;
        border-radius: 5px;
        padding: 15px 0;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .bottom {
        border-radius: 5px;
        border: 1px solid #193060;
        padding: 15px 0;
        cursor: pointer;
      }
    }
  }
  .link-text{
    color: #fec000;
  }
  .agree-text {
    max-width: 600px;
    font-size: 14px;
    font-weight: 400;
    color: #ee8515;
    line-height: 20px;
    margin-bottom: 20px;
    position: relative;
  }
  /deep/ .el-checkbox__input{
    vertical-align: top;
    margin-top: 2px;
  }
  /deep/ .el-checkbox__label{
    white-space: normal !important;
  }
  .agree-mask{
    position: absolute;
    z-index: 10;
    background: rgba(179, 179, 179, 0);
    top: -5px;
    left: -5px;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    cursor: pointer;
  }
  .left-content{
    flex: 1;
    margin-right: 30px;
  }
  .right-content {
    width: 160px;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  @media (max-width: 768px) {
    .right-content{
      width: 100px;
    }
    .left-content{
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
